export const PAGES_WITHOUT_SIDEBAR = [
  'home',
  'login',
  // public survey preview
  'survey',
]
